import styled from 'styled-components';

import { ReactComponent as closeIcon } from '../icons/close-icon.svg';
import { ReactComponent as rightArrowIcon } from '../icons/right-arrow-icon.svg';
import { ReactComponent as downArrowIcon } from '../icons/down-arrow-icon.svg';
import { ReactComponent as rightLinkArrowIcon } from '../icons/right-link-arrow-icon.svg';
import { ReactComponent as searchIcon } from '../icons/search-icon.svg';
import { ReactComponent as remoteSessionIcon } from '../icons/remote-session-icon.svg';
import { ReactComponent as noResultsIcon } from '../icons/no-results-icon.svg';

export const CloseIconStyled = styled(closeIcon)`
	display: inline-block;
	width: 34px;
	height: 34px;
	opacity: 1;
	transition: opacity 350ms;
	&:hover {
		opacity: 0.75;
		cursor: pointer;
	}

	&.search-reset {
		display: inline-block;
		width: 34px;
		height: 34px;
		z-index: 9;
		position: absolute;
		right: 0;
		top: 50%;
		transform: translateY(-50%);
		margin-right: ${({ theme }) => theme.variables.margin * 0.5}px;
	}
`;

export const RightArrowIconStyled = styled(rightArrowIcon)`
	display: inline-block;
	width: 8px;
	height: 14px;
`;

export const RightLinkArrowIconStyled = styled(rightLinkArrowIcon)`
	display: inline-block;
	width: 26px;
	height: 13px;
`;

export const SearchIconStyled = styled(searchIcon)`
	display: inline-block;
	width: 21px;
	height: 21px;
	z-index: 9;
	position: absolute;
	right: 0;
	top: 50%;
	transform: translateY(-50%);
	margin-right: ${({ theme }) => theme.variables.margin * 0.5}px;
`;

export const DownArrowIconStyled = styled(downArrowIcon)`
	display: inline-block;
	width: 14px;
	height: 8px;
	z-index: 9;
	position: absolute;
	right: 0;
	top: 50%;
	transform: translateY(-50%);
	margin-right: ${({ theme }) => theme.variables.margin * 0.5}px;
`;

export const RemoteSessionIconStyled = styled(remoteSessionIcon)`
	display: inline-block;
	width: 36px;
	height: 34px;
`;

export const NoResultsIconStyled = styled(noResultsIcon)`
	display: inline-block;
	width: 30px;
	height: 30px;
	color: ${({ theme }) => theme.colors.quinaryColor};
`;
